






















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditWareHouse from "./edit-warehouse.vue";
import CreateWareHouse from "./create-warehouse.vue";
import Auth from '../../../lib/Judgeauthority';
class PageWareHouseRequest extends PageRequest {
  FilterText: string;
}
@Component({
  components: { EditWareHouse, CreateWareHouse },
})
export default class WareHouses extends AbpBase {
  pagerequest: PageWareHouseRequest = new PageWareHouseRequest();
  publicpagerequest: PageWareHouseRequest = new PageWareHouseRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  searchInt:number = 0;
  showAddButton = false;
  get list() {
    return this.$store.state.warehouse.list;
  }
   companylist() {
     
    return this.$store.state.company.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  selfactory(value:Number){
      this.searchInt = 1;
       this.getpage();
  }
  get loading() {
    return this.$store.state.warehouse.loading;
  }
  pageChange(page: number) {
    this.$store.commit("warehouse/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("warehouse/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.searchInt = 1;
    this.getpage();
  }
  async getpage() {
    if(this.searchInt == 1){
      this.$store.state.thequipment.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else
    {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    //filters
    await this.$store.dispatch({
      type: "warehouse/GetPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.warehouse.pageSize;
  }
  get totalCount() {
    return this.$store.state.warehouse.totalCount;
  }
  get currentPage() {
    return this.$store.state.warehouse.currentPage;
  }
  userName() {
    //console.log(this.$store.state.session.user);
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区名称",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房名称",
      key: "wName",
    },
    {
      title: "库房编号",
      key: "number",
    },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        this.userName();
        if (status == 1) {
          status = "启用";
        } else if (status == 0) {
          status = "停用";
        }
        return h("span", status);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
         let strupdate = h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("warehouse/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          );
           //判断是否有修改权限
        if (!Auth.getauthority("Pages.Warehouses_Update")) {
          strupdate = null;
        }
         let strdelete = h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "warehouse/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          );
          //判断是否有删除权限
        if (!Auth.getauthority("Pages.Warehouses_Delete")) {
          strdelete = null;
        }
        return h("div", [strupdate, strdelete]);
      },
    },
  ];
  ///根据权限返回列数据
  get filterColumns() {
    if (
      !Auth.getauthority("Pages.Warehouses_Update") &&
      !Auth.getauthority("Pages.Warehouses_Delete")
    ) {
      return this.columns.filter((col) => col.key !== "Actions");
    }
    return this.columns;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      //-
      data: this.publicpagerequest,
    });
  }
  created() {
    if (this.userName() !== "admin") {
      this.getfactory()
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
     
    this.getpage();
     if (Auth.getauthority("Pages.Warehouses_Create")) {
      this.showAddButton = true;
    }
  }
}
